import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import "@/pages/pages.css";
import HomeGallery from "@/pages/HomeGallery";
import GridGallery from "@/pages/GridGallery";
import PaintingDetail from "@/pages/PaintingDetail";
import BlogList from "@/pages/BlogList";
import BlogPost from "@/pages/BlogPost";
import "@/pages/blog.css";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomeGallery />} />
        <Route path="/paintings" element={<GridGallery />} />
        <Route path="/paintings/:slug" element={<PaintingDetail />} />
        <Route path="/blog" element={<BlogList />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="*" element={<HomeGallery />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
